/**
 * Helper functions for ContentViewModel mapping
 * Extracted from ExtrasItemRenderer.tsx for reuse in MVVM layer
 */

import { Content } from '../model/extras.domain';
import { getVideoThumbnail } from '../video/video.mappers';
import { toLegacyGuideURL } from './extras.mappers';

/**
 * Get image URL for content item based on type
 */
export const getContentImageUrl = (content: Content): string => {
  switch (content.type) {
    case 'ContentLegacyGuide':
      // Legacy guides use contentId to build thumbnail URL
      return toLegacyGuideURL(content.value.contentId);

    case 'ContentLink':
      return content.value.coverImage || '';

    case 'ContentSlides':
      return content.value.coverURL || '';

    case 'ContentPDF':
      return content.value.coverURL || '';

    case 'ContentVideo':
      return getVideoThumbnail(content.value);

    case 'ContentImage':
      return content.value.url || '';

    case 'ContentTab':
      return ''; // Tabs don't have images

    default:
      return '';
  }
};
